module.exports = __webpack_public_path__ + "static/media/image-7.c067e772.jpg";